<template>
  <div id="chart">
    <apexchart
      type="line"
      height="350"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>
<script>
import axios from "axios";
const lastWeekApi =
  "https://bookinga.herokuapp.com/api/v1/adminReport/company/lastweek";
export default {
  mounted() {
    var token = localStorage.getItem("jwt");
    const headers = { Authorization: `Bearer ${token}` };
    axios.get(lastWeekApi, { headers }).then((res) => {
      const data = res.data.result;
      const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
      var ticketsData = [];
      days.forEach((day) => {
        var DayTickets = [];
        if (data)
          for (let i = 0; i < data.length; i++) {
            if (day == data[i].day) {
              DayTickets.push(Number(data[i].ticketsold));
            }
          }
        ticketsData.push({
          dayName: day,
          tickets: DayTickets,
        });
      });
      var lowerTickets = [];
      var higherTickets = [];
      ticketsData.forEach((ticketData) => {
        lowerTickets.push(this.findLowNumber(ticketData.tickets));
        higherTickets.push(this.findMaxNumber(ticketData.tickets));
      });
      this.series.push(
        {
          name: "Low",
          data: lowerTickets,
        },
        {
          name: "High",
          data: higherTickets,
        }
      );
    });
  },
  methods: {
    findLowNumber(array) {
      if (array.length == 0) {
        return 0;
      }
      return Math.min.apply(Math, array);
    },
    findMaxNumber(array) {
      if (array.length == 0) {
        return 0;
      }
      return Math.max.apply(Math, array);
    },
  },
  data() {
    return {
      series: [],
      chartOptions: {
        chart: {
          height: 350,
          type: "line",
          dropShadow: {
            enabled: true,
            color: "#000",
            top: 18,
            left: 3,
            blur: 3,
            opacity: 0.2,
          },
          toolbar: {
            show: false,
          },
        },
        colors: ["#77B6EA", "#545454"],
        dataLabels: {
          enabled: true,
        },
        stroke: {
          curve: "smooth",
        },
        title: {
          text: "Ticket selling graph for last week",
          align: "left",
        },
        grid: {
          borderColor: "#e7e7e7",
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        markers: {
          size: 10,
        },
        xaxis: {
          categories: ["Mon", "Tues", "Wedn", "Thu", "Fri", "Sat", "Sun"],
          title: {
            text: "Last week days",
          },
        },
        yaxis: {
          title: {
            text: "Tickets Number",
          },
        },
        legend: {
          position: "top",
          horizontalAlign: "right",
          floating: true,
          offsetY: -25,
          offsetX: -5,
        },
      },
    };
  },
};
</script>

<style></style>
